export default "__VITE_ASSET__BpqT_PDs__"